<template>
  <div>
    <div v-if="!filtersApplied" class="w-full flex flex-col items-center fade-in">
      <img src="https://publicassets.foreplay.co/spyder-empty.png" style="width: 226px; height: 162px;">
      <BaseText type="heading" size="md" class="text-black mt-9">
        We're still collecting ads
      </BaseText>
      <BaseText type="body" size="md" class="text-text-normal mt-2 text-center" style="max-width: 390px;">
        Spyder brands are automatically updated daily with new ads from Facebook's Ad Library.
      </BaseText>
      <router-link :to="{ name: 'SpyderBrandsView' }" class="secondary-btn flex items-center gap-1.5 pl-2 pr-3 py-1.5 rounded-md mt-9">
        <SpyderIcon class="text-icon-normal" />
        <BaseText type="label" size="sm" class="text-text-muted">
          Spyder Brands
        </BaseText>
      </router-link>
    </div>
    <div v-else class="w-full flex flex-col items-center fade-in">
      <img src="https://publicassets.foreplay.co/spyder-empty.png" style="width: 226px; height: 162px;">
      <BaseText type="heading" size="md" class="text-black mt-9">
        {{ hasSearchQuery ? 'No results found' : 'Too many filters' }}
      </BaseText>
      <BaseText type="body" size="md" class="text-text-normal mt-2 text-center" style="max-width: 390px;">
        We were unable to find any ads that meet your filter or search criteria.
      </BaseText>
      <button class="secondary-btn flex items-center gap-1.5 pl-2 pr-3 py-1.5 rounded-md mt-9"
      @click="$emit('clearFilters')">
        <ClearFiltersIcon class="text-icon-normal" />
        <BaseText type="label" size="sm" class="text-text-muted">
          Clear filters
        </BaseText>
      </button>
    </div>
  </div>
</template>

<script>
import SpyderIcon from '../globals/Icons/SidebarIcons/SpyderIcon.vue'
import ClearFiltersIcon from '../globals/Icons/FilterIcons/ClearFiltersIcon.vue'

export default {
  name: 'SpyderEmptyState',
  components: {
    SpyderIcon,
    ClearFiltersIcon
  },
  props: {
    filtersApplied: {
      type: Boolean,
      default: false
    },
    hasSearchQuery: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.secondary-btn {
  box-shadow: 0 1px 2px 0 rgba(4, 26, 75, 0.13), 0 0 0 1px rgba(0, 56, 108, 0.08);
  background-color: transparent;
  transition: background-color 100ms ease-in-out, box-shadow 100ms ease-in-out;
}
.secondary-btn:hover {
  box-shadow: none;
  background-color: #F6F8FA;
}
.fade-in {
  animation: fadeIn 100ms ease-in-out;
}
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}
</style>